<template>
  <validation-observer ref="refFormObserver">
    <b-form slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)">
      <!-- Name -->
      <b-form-group label="Name" class="mb-3">
        <form-input
          v-model="salesTypeFormData.name"
          :disabled="loading"
          name="Name"
          rules="required"
          placeholder="Enter sales type name"
        />
      </b-form-group>

      <!-- Code -->
      <b-form-group label="Code" class="mb-3">
        <form-input
          v-model="salesTypeFormData.code"
          :disabled="loading"
          name="Code"
          rules="required"
          placeholder="Enter sales type code"
        />
      </b-form-group>

      <!-- Prefix -->
      <b-form-group label="Prefix" class="mb-3">
        <form-input
          v-model="salesTypeFormData.prefix"
          :disabled="loading"
          name="Prefix"
          rules="required"
          placeholder="Enter sales type prefix"
        />
      </b-form-group>

      <!-- Is Active -->
      <b-form-group label="Status" class="mb-3">
        <b-form-checkbox
          id="sales-type-active"
          v-model="salesTypeFormData.isActive"
          name="sales-type-active"
          value="true"
          unchecked-value="false"
          :disabled="loading"
        >
          Active
        </b-form-checkbox>
      </b-form-group>

      <b-button type="submit" variant="primary" :disabled="loading">
        <b-spinner small v-if="loading" class="mr-1"></b-spinner>
        {{ loading ? 'Saving...' : 'Save Sales Type' }}
      </b-button>
    </b-form>
  </validation-observer>
</template>

<script>
import { BForm, BFormGroup, BFormCheckbox, BButton, BSpinner } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ref, computed, watch } from '@vue/composition-api';
import store from '@/store';
import FormInput from '@/views/apps/fbr-invoice/components/form/FormInput.vue';

export default {
  name: 'SalesTypeForm',
  components: {
    BForm,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BSpinner,

    // Form Validation
    ValidationObserver,
    ValidationProvider,

    // Custom Components
    FormInput,
  },
  model: {
    prop: 'formData',
    event: 'update:form-data',
  },
  props: {
    formData: {
      type: Object | null,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const businessID = computed(() => store.state.user.businessID);

    const salesTypeFormData = ref(
      props.formData
        ? JSON.parse(JSON.stringify(props.formData))
        : {
            id: 0,
            name: '',
            code: '',
            prefix: '',
            isActive: true,
            businessID: businessID.value,
          }
    );

    const onSubmit = async () => {
      console.log('Emitting:', JSON.stringify(salesTypeFormData.value, null, 2));
      emit('submit');
    };

    watch(
      salesTypeFormData,
      (newVal) => {
        emit('update:form-data', newVal);
      },
      { deep: true }
    );

    return {
      salesTypeFormData,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
.b-card {
  margin-bottom: 1rem;
}
</style>
